import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { getPlan } from "../../../../../contexts/PlanOperationContext/Plan";
import { useSelector } from "../../../../../util/store/store";
import { getMondayByKey } from "../../../../../util/varibles/global";
import { selectPlan } from "../../../constants";
import { planOpActions } from "../../../reducer";
import styles from "../style.module.scss";

interface IProps {
    calendarWidth: number
}

const LazyLoading: React.FC<IProps> = (props) => {
    const get = getPlan();
    const style = { width: `${props.calendarWidth}%` };
    const [loadMore, setLoadMore] = useState<number>(0);
    const weeks = useSelector(selectPlan.weeks);
    const scrollAnchor = useRef<{ dayId: string, offset: number } | null>(null);
    const dispatch = useDispatch()

    useLayoutEffect(() => {
        const anchor = scrollAnchor.current;
        if (!anchor || `${getMondayByKey(weeks[0]).time}` === anchor.dayId)
            return;

        const { calendarRef } = get();
        const calendar = calendarRef?.();
        const dayElement = document.getElementById(anchor.dayId);
        if (calendar && dayElement) {
            const offset = dayElement.getBoundingClientRect().top - calendar.getBoundingClientRect().top;
            calendar.scrollTop += offset - anchor.offset;
            void calendar.offsetHeight;
            delete calendar.dataset.preserveScroll;
            scrollAnchor.current = null;
        }
    }, [get, weeks]);

    useEffect(() => {
        if (loadMore === 0) {
            const { calendarRef } = get();
            const calendar = calendarRef?.();
            if (calendar)
                delete calendar.dataset.preserveScroll;
            scrollAnchor.current = null;
        }
    }, [get, loadMore]);

    useEffect(() => {
        const { calendarRef } = get();
        const el = calendarRef?.();
        const action = () => setLoadMore(0);
        const handleWheel = (e: WheelEvent) => {
            const { deltaY } = e;

            setLoadMore(prev => {
                if (prev) return prev;
                const { scrollTop, scrollHeight, offsetHeight } = el as HTMLElement;
                const isScrolledToTop = scrollTop + deltaY <= 0;
                const isScrolledToBottom = (scrollHeight - offsetHeight - (scrollTop + deltaY)) < 0;
                if (isScrolledToTop && deltaY < 0) {
                    const dayId = `${getMondayByKey(weeks[0]).time}`;
                    const dayElement = document.getElementById(dayId);
                    if (dayElement) {
                        el!.dataset.preserveScroll = 'true';
                        scrollAnchor.current = {
                            dayId,
                            offset: dayElement.getBoundingClientRect().top - el!.getBoundingClientRect().top,
                        };
                    }
                    setTimeout(() => dispatch(planOpActions.lazyLoadingRequest({ key: 'beforeCount', action })), 100)
                    return 1
                } else if (isScrolledToBottom && deltaY > 0) {
                    setTimeout(() => dispatch(planOpActions.lazyLoadingRequest({ key: 'afterCount', action })), 100)
                    return 2;
                } else if (prev !== 0)
                    return 0;

                return prev;
            })
        }

        if (el)
            el.addEventListener('wheel', handleWheel)

        return () => {
            if (el)
                el.removeEventListener('wheel', handleWheel)
        }
    }, [dispatch, get, weeks]);

    return <>
        <div className={styles['loading-top']} data-is-show={loadMore === 1} style={style}>
            <div className={styles['container-loading']}>
                <div className=' spinner-border text-secondary' role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div className={styles['loading-bottom']} data-is-show={loadMore === 2} style={style}>
            <div className={styles['container-loading']}>
                <div className=' spinner-border text-secondary' role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </>;
};

export default LazyLoading;